import http from '@/api/http'

export default {
  getInfo () {
    return http.get('/cs/auth/user')
  },
  logout () {
    // return http.delete('/api/logout')
    return http.post('http://auth.begind.cn/logout')
  }
}



// WEBPACK FOOTER //
// ./src/api/login.js